import { configureStore } from '@reduxjs/toolkit';
import { combineReducers } from 'redux';
import createSagaMiddleware from 'redux-saga';
import handleAPIStatusSlice from '../reducers/handle-api-status/slice';
import overViewSlice from '../reducers/overview/slice';
import pecrDataSlice from '../reducers/pecr-info/slice';
import pecrURLDataSlice from '../reducers/pecr-url-data/slice';
import resourceModificationDataSlice from '../reducers/resource-modification-data/slice';
import userInfoSlice from '../reducers/user-info/slice';

const sagaMiddleware = createSagaMiddleware();
export const store = configureStore({
  reducer: {
    pecrURLData: pecrURLDataSlice,
    userInfo: userInfoSlice,
    resourceModificationData: resourceModificationDataSlice,
    pecrInfo: combineReducers({
      overview: overViewSlice,
      pecrData: pecrDataSlice,
    }),
    errorNotification: handleAPIStatusSlice,
  },
  middileware: [sagaMiddleware],
});
